module.exports = __webpack_public_path__ + "img/optical3.115a4dee.jpeg";